import React, { useState, useEffect, useRef } from 'react';

function Gerisayim() {
  const [kalanSure, setKalanSure] = useState(baslangicZamaniHesapla());
  const gerisayimElementi = useRef(null);

  useEffect(() => {
    const bitisZamani = new Date('2024-01-10T11:00:00').getTime();

    const gerisayim = setInterval(() => {
      const simdikiZaman = new Date().getTime();
      const kalanSure = bitisZamani - simdikiZaman;

      setKalanSure(kalanSure);

      if (kalanSure < 0) {
        clearInterval(gerisayim);
      }
    }, 1000);

    return () => clearInterval(gerisayim);
  }, []);

  function baslangicZamaniHesapla() {
    const bitisZamani = new Date('2024-01-10T11:00:00').getTime();
    return bitisZamani - new Date().getTime();
  }

  function ikiHaneliYap(sayi) {
    return sayi < 10 ? '0' + sayi : sayi;
  }

  const gun = ikiHaneliYap(Math.floor(kalanSure / (1000 * 60 * 60 * 24)));
  const saat = ikiHaneliYap(Math.floor((kalanSure % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
  const dakika = ikiHaneliYap(Math.floor((kalanSure % (1000 * 60 * 60)) / (1000 * 60)));
  const saniye = ikiHaneliYap(Math.floor((kalanSure % (1000 * 60)) / 1000));

  return (
    <div className="clock-container">
      <div className='container'>
        <div className='box'>
          <div className='detail'>
            <div className='icon'><i class="bi bi-calendar-week"></i></div>
            <div className='title'>
              <span className='name'>ORTA KARADENİZ KARİYER FUARI</span>
              <span>GERİ SAYIM BAŞLADI</span>
            </div>
          </div>
          <div className="line" ref={gerisayimElementi}>
            <div className="clock-col">
              <p className="clock-timer">00</p>
              <p className="clock-label">Gün</p>
            </div>
            <div className="clock-col">
              <p className="clock-timer">00</p>
              <p className="clock-label">Saat</p>
            </div>
            <div className="clock-col">
              <p className="clock-timer">00</p>
              <p className="clock-label">Dakika</p>
            </div>
            <div className="clock-col">
              <p className="clock-timer">00</p>
              <p className="clock-label">Saniye</p>
            </div>
          </div>
          <div className='visitor-hours'>
            <div className='head'>ZİYARETÇİ SAATLERİ</div>
            <div className='body'>
              <span>AÇILIŞ: 09:00</span>
              <span>KAPANIŞ: 17:30</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gerisayim;
